import React from 'react'
import { Box, Stack } from '@mui/system'
import InstallationLink from 'src/Elements/Installations/InstallationLink'
import { getEmsProductImage } from 'src/Libs/installations/utils/product-image'
import { Statement } from 'src/Libs/installations/types'

interface MissingIbnInstallationLinkMobileProps {
  item: Statement
}

/**
 * display missing ibn installation table's 'installationId' information.
 */
const MissingIbnInstallationLinkMobile: React.FC<MissingIbnInstallationLinkMobileProps> = ({ item }) => {
  const { installationId, deviceId, partnersInstallationName, owner, type } = item

  return (
    <Stack flexDirection="row" alignItems="center" gap={2}>
      <Box component="img" src={getEmsProductImage(type)} alt="" sx={{ width: '35', height: '35' }} />
      <Stack>
        <InstallationLink
          installation={{
            id: installationId,
            emsMasterDeviceId: deviceId,
            partnersInstallationName: partnersInstallationName,
            installationStatus: 'incomplete',
          }}
          displayStorageNumber
        />
        {!partnersInstallationName && owner ? owner : ''}
      </Stack>
    </Stack>
  )
}

export default MissingIbnInstallationLinkMobile
